module.exports = __webpack_public_path__ + "img/15.9613d157.png";